module.exports = __webpack_public_path__ + "static/media/artist_workshop_4k.c8ed2d4b.png";